import { injectable } from 'inversify';
import { UserFavoriteUnit, UserFavoriteUnitOption } from '@Models';
import {
  user_favorite_unit_dto,
  user_favorite_unit_full,
  user_favorite_unit_option_dto,
  user_favorite_unit_option_full,
} from '@Api';

@injectable()
export class UserFavoriteUnitMapper {
  public map(item: user_favorite_unit_full): UserFavoriteUnit {
    return {
      id: item.id,
      unitId: item.unit_id,
      name: item.name,
      unitOptions: item.unit_options.map((unitOption) =>
        this.mapOption(unitOption),
      ),
    };
  }

  public mapOption(
    item: user_favorite_unit_option_full,
  ): UserFavoriteUnitOption {
    return {
      id: item.id,
      unitOptionId: item.unit_option_id,
      quantity: item.quantity,
    } satisfies UserFavoriteUnitOption as UserFavoriteUnitOption;
  }

  mapDto(favoriteUnit: UserFavoriteUnit): user_favorite_unit_dto {
    return {
      id: favoriteUnit.id != '' ? favoriteUnit.id : null,
      unit_id: favoriteUnit.unitId,
      name: favoriteUnit.name,
      unit_options_attributes: favoriteUnit.unitOptions.map(
        (option) =>
          ({
            id: option.id != '' ? option.id : null,
            unit_option_id: option.unitOptionId,
            quantity: option.quantity,
          }) satisfies user_favorite_unit_option_dto as user_favorite_unit_option_dto,
      ),
    } satisfies user_favorite_unit_dto as user_favorite_unit_dto;
  }
}
